// Copyright (c) StrangeBee 2023

import { AnalyzerTemplateController, AnalyzerTemplateImportOutput, AnalyzerTemplateOutput } from 'thehive-sdk';

export interface EventListOutput {
    onList: () => Promise<AnalyzerTemplateOutput[]>;
    onGet: (analyzerId: string) => Promise<AnalyzerTemplateOutput[]>;
    onEdit: (data: Partial<AnalyzerTemplateOutput>, id: string) => Promise<void>;
    onCreate: (data: Partial<AnalyzerTemplateOutput>) => Promise<void>;
    onDelete: (fvalues: string) => Promise<void>;
    onImport: (formData: FormData) => Promise<AnalyzerTemplateImportOutput>;
}

interface EventListParams {
    controller: AnalyzerTemplateController;
    onSuccess?: (message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({ controller, onError, onSuccess }: EventListParams): EventListOutput => ({
    onList: (): Promise<AnalyzerTemplateOutput[]> =>
        controller.list({
            selector: {
                head: [{ name: 'listAnalyzerTemplate' }],
                name: 'get-all-analyzer-templates',
            },
            sort: ['+analyzerId'],
        }),
    onGet: (analyzerId: string): Promise<AnalyzerTemplateOutput[]> =>
        controller.list({
            selector: {
                head: [{ name: 'listAnalyzerTemplate' }],
                name: `get-analyzer-template-${analyzerId}`,
            },
            filters: [
                {
                    field: 'analyzerId',
                    values: [analyzerId],
                    type: 'string',
                    operator: 'any',
                },
            ],
            sort: ['+analyzerId'],
        }),
    onDelete: (objectId): Promise<void> =>
        controller.delete(objectId).then(
            () => onSuccess?.(),
            () => onError?.(),
        ),
    onEdit: (data, objectId): Promise<void> =>
        controller.edit(data, objectId).then(
            () => onSuccess?.(),
            () => onError?.(),
        ),
    onCreate: (data): Promise<void> =>
        controller.create(data).then(
            () => onSuccess?.(),
            () => onError?.(),
        ),
    onImport: (formData: FormData): Promise<AnalyzerTemplateImportOutput> => controller.import(formData),
});
